import { render, staticRenderFns } from "./RecordMessage.vue?vue&type=template&id=c8c9c0c2&scoped=true&"
import script from "./RecordMessage.vue?vue&type=script&lang=js&"
export * from "./RecordMessage.vue?vue&type=script&lang=js&"
import style0 from "./RecordMessage.vue?vue&type=style&index=0&id=c8c9c0c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8c9c0c2",
  null
  
)

component.options.__file = "RecordMessage.vue"
export default component.exports